import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, NavbarElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type NavbarProps = RecursivePartial<NavbarElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | NavbarElement["children"];
  data?: NavbarElement["data"];
};

export function Navbar(props: NavbarProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: NavbarElement = {
    type: BasicType.NAVBAR,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
